import React from "react";
import { WithLazy } from "@quintype/components";

import HoroscopeGrid from "../../molecules/horoscope-grid";
import Separator from "../../atoms/separator";

import "./horoscope-collection.m.css";

const HoroscopeCollection = ({ collection }) => {
  return (
    <WithLazy>
      {() => (
        <div styleName="border-wrapper">
          <div styleName="wrapper">
            <div styleName="horoscope-wrapper">
              <h1 styleName="collection-name">{collection.metadata?.["display-name"] || collection?.name}</h1>
              <div styleName="content">
                <HoroscopeGrid />
              </div>
            </div>
          </div>
          <Separator />
        </div>
      )}
    </WithLazy>
  );
};

export default HoroscopeCollection;
